module.exports = __webpack_public_path__ + "4ef502528807a6c8b0dc0b492668b9da.jpg";